import { useEffect, useState, useMemo } from "react"
import { useBuscaCEP } from "../pages/Wallet/hooks/useWallet"
import { dbCep, db } from "../db/db"
import { useLiveQuery } from "dexie-react-hooks"
import useWorker from "~hooks/useWorker"

const useCeps = ({ codigoPostal = '', handleError }) => {
  const [loading, setLoading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [cidadePorFaixa, setCidadePorFaixa] = useState(null)
  const [siglaEstado, setSiglaEstado] = useState("")

  const cepRequest = useBuscaCEP(codigoPostal, enabled, handleError)

  const ceps = useLiveQuery(() =>
    dbCep.cep.where("cep").equals(codigoPostal).first(),
    [codigoPostal]
  )

  const { save } = useWorker({ table: "cep" })

  useEffect(() => {
    if (cepRequest.data) {
      save(cepRequest.data)
    }
  }, [cepRequest.data])

  useEffect(() => {
    const buscarPorFaixa = async () => {
      if (!ceps && !cepRequest.data && codigoPostal) {
        const cepNumber = parseInt(codigoPostal, 10)
        const cidades = await db.cidades.toArray()

        const cidadeEncontrada = cidades.find((cidade) => {
          const inicio = parseInt(cidade.faixaCepInicio, 10)
          const fim = parseInt(cidade.faixaCepFim, 10)
          return cepNumber >= inicio && cepNumber <= fim
        })

        if (cidadeEncontrada) {
          setCidadePorFaixa(cidadeEncontrada)
          const estado = await db.estados.get(cidadeEncontrada.estadoId)
          if (estado?.sigla) {
            setSiglaEstado(estado.sigla)
          }
        } else {
          const proximas = cidades
            .map((cidade) => {
              const inicio = parseInt(cidade.faixaCepInicio, 10)
              const fim = parseInt(cidade.faixaCepFim, 10)
              const distancia =
                cepNumber < inicio
                  ? inicio - cepNumber
                  : cepNumber > fim
                  ? cepNumber - fim
                  : 0
              return { ...cidade, distancia }
            })
            .sort((a, b) => a.distancia - b.distancia)
            .slice(0, 5)

          // console.table(proximas.map(p => ({
          //   nome: p.nome,
          //   faixaCepInicio: p.faixaCepInicio,
          //   faixaCepFim: p.faixaCepFim,
          //   distancia: p.distancia
          // })))
        }

        setLoading(false)
      }
    }

    buscarPorFaixa()
  }, [ceps, cepRequest.data, codigoPostal])

  const cep = useMemo(() => {
    if (ceps) {
      setLoading(false)
      return ceps
    }

    if (cidadePorFaixa) {
      setLoading(false)
      return {
        cep: codigoPostal,
        logradouro: "",
        bairro: "",
        cidadeId: cidadePorFaixa.id,
        sigla: siglaEstado || "",
        cidadePorFaixa,
        fallback: true,
      }
    }

    return {}
  }, [ceps, cidadePorFaixa, siglaEstado])

  useEffect(() => {
    if (codigoPostal) {
      setLoading(true)
      setEnabled(true)
    }
  }, [codigoPostal])

  return {
    loading,
    cep,
  }
}

export default useCeps
